import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Heart, CheckCircle2, Sun, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
interface TodayInSkyProps {
  onNavigate: (page: string) => void;
}
export function TodayInSky({
  onNavigate
}: TodayInSkyProps) {
  return <AnimatedSection className="py-8 sm:py-20 bg-white" data-id="element-13962">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13963">
        <div className="flex justify-between items-end mb-4 sm:mb-10" data-id="element-13964">
          <div data-id="element-13965">
            <h2 className="text-lg sm:text-3xl font-bold text-slate-900 mb-1 sm:mb-2" data-id="element-13966">
              Сегодня в небе
            </h2>
            <p className="text-slate-500 text-xs sm:text-base" data-id="element-13967">
              Актуальные транзиты и рекомендации на день
            </p>
          </div>
          <Button variant="ghost" className="hidden md:flex text-slate-500" onClick={() => onNavigate('astro-daily')} data-id="element-13968">
            Полный календарь <ArrowRight className="ml-2 w-4 h-4" data-id="element-13969" />
          </Button>
        </div>

        {/* Mobile: horizontal scroll */}
        <div className="sm:hidden flex gap-3 overflow-x-auto pb-2 -mx-4 px-4 snap-x snap-mandatory" style={{
        scrollbarWidth: 'none'
      }} data-id="element-13970">
          {[{
          icon: <Moon className="w-4 h-4" data-id="element-13971" />,
          title: 'Луна в Скорпионе',
          desc: 'Глубокий самоанализ и трансформация',
          bg: 'bg-indigo-50',
          text: 'text-indigo-600'
        }, {
          icon: <Heart className="w-4 h-4" data-id="element-13972" />,
          title: 'Венера в Стрельце',
          desc: 'Путешествия и новые знакомства',
          bg: 'bg-rose-50',
          text: 'text-rose-600'
        }, {
          icon: <CheckCircle2 className="w-4 h-4" data-id="element-13973" />,
          title: 'Меркурий директный',
          desc: 'Можно подписывать документы',
          bg: 'bg-emerald-50',
          text: 'text-emerald-600'
        }, {
          icon: <Sun className="w-4 h-4" data-id="element-13974" />,
          title: 'До затмения: 14 дней',
          desc: 'Кармические перемены',
          bg: 'bg-amber-50',
          text: 'text-amber-600'
        }].map((item, i) => <div key={i} className="flex-shrink-0 w-[200px] snap-center bg-white rounded-xl border border-slate-100 p-3" data-id="element-13975">
              <div className={`w-8 h-8 rounded-lg ${item.bg} ${item.text} flex items-center justify-center mb-2`} data-id="element-13976">
                {item.icon}
              </div>
              <h4 className="font-bold text-slate-900 text-xs mb-1" data-id="element-13977">
                {item.title}
              </h4>
              <p className="text-[10px] text-slate-500 leading-snug" data-id="element-13978">
                {item.desc}
              </p>
            </div>)}
        </div>

        {/* Desktop: grid */}
        <motion.div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-4" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-13979">
          {[{
          icon: <Moon className="w-5 h-5" data-id="element-13980" />,
          title: 'Луна в Скорпионе',
          desc: 'День подходит для глубокого самоанализа и трансформации',
          bg: 'bg-indigo-50',
          text: 'text-indigo-600'
        }, {
          icon: <Heart className="w-5 h-5" data-id="element-13981" />,
          title: 'Венера в Стрельце',
          desc: 'Благоприятно для путешествий и новых знакомств',
          bg: 'bg-rose-50',
          text: 'text-rose-600'
        }, {
          icon: <CheckCircle2 className="w-5 h-5" data-id="element-13982" />,
          title: 'Меркурий директный',
          desc: 'Коммуникации восстановлены, можно подписывать документы',
          bg: 'bg-emerald-50',
          text: 'text-emerald-600'
        }, {
          icon: <Sun className="w-5 h-5" data-id="element-13983" />,
          title: 'До затмения: 14 дней',
          desc: 'Солнечное затмение в Весах — время кармических перемен',
          bg: 'bg-amber-50',
          text: 'text-amber-600'
        }].map((item, i) => <motion.div key={i} variants={staggerItem} data-id="element-13984">
              <Card padding="md" className="border-slate-100 h-full" data-id="element-13985">
                <div className={`w-10 h-10 rounded-xl ${item.bg} ${item.text} flex items-center justify-center mb-4`} data-id="element-13986">
                  {item.icon}
                </div>
                <h4 className="font-bold text-slate-900 mb-2" data-id="element-13987">{item.title}</h4>
                <p className="text-sm text-slate-500 leading-relaxed" data-id="element-13988">
                  {item.desc}
                </p>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </AnimatedSection>;
}